import { useContext, useEffect, useState } from "react";
import { PricingPortalAPI } from "../apis/pricing-api";
import { DisplaySpinnerContext } from "../context/ContextIndex";

const useFetchListData = (businessCode, countryCode, serviceName, list, filter = { required: false, clause: null }) => {
  const [listData, setListData] = useState();
  const spinnerCtx = useContext(DisplaySpinnerContext);

  useEffect(() => {
    const fetchListData = async () => {
      try {
        let _list = [];
        if (filter.required) {
          if (filter.clause) {
            _list = await PricingPortalAPI.getFilterList(businessCode, countryCode, serviceName, list, filter.clause);
          }
        } else {
          _list = await PricingPortalAPI.getList(businessCode, countryCode, serviceName, list);
        }

        await setListData(_list);
      } catch (e) {
        spinnerCtx.setLoadingIndicator(false);
        alert(e);
      }
    };
    fetchListData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return listData;
};

export { useFetchListData };
